import { CircleSkeleton, RectangleSkeleton } from "./components/skeleton";
import styles from "./styles.scss";

export const ResultListItemSkeleton = () => (
  <li className={styles.skeletonItemContainer}>
    <CircleSkeleton className={styles.skeletonAvatar} diameter={40} />
    <div className={styles.skeletonInfo}>
      <RectangleSkeleton className={styles.skeletonLine} height={20} />
      <RectangleSkeleton
        className={styles.skeletonLine}
        height={12}
        width="75%"
      />
      <RectangleSkeleton
        className={styles.skeletonLine}
        height={12}
        width="90%"
      />
    </div>
  </li>
);

export const ResultsListSkeleton = () => (
  <div className={styles.skeletonContainer}>
    <ResultListItemSkeleton />
    <ResultListItemSkeleton />
    <ResultListItemSkeleton />
    <ResultListItemSkeleton />
    <ResultListItemSkeleton />
  </div>
);
